/**
 * The command type for updating a participant's avatar URL.
 *
 * @type {string}
 */
export const AVATAR_URL_COMMAND = 'avatar-url';

/**
 * The command type for updating a participant's e-mail address.
 *
 * @type {string}
 */
export const EMAIL_COMMAND = 'email';

/**
 * The command type for updating a participant's designation.
 *
 * @type {string}
 */
export const DESIGNATION_COMMAND = 'designation';

/**
 * The command type for updating a participant's organization.
 *
 * @type {string}
 */
export const ORGANIZATION_COMMAND = 'organization';

export const navigationBarMenuButtonRect = {
    current: null
};

export const layoutButtonRect = {
    current: null
};

export const shareMenuButtonRect = {
    current: null
};

export const connectionButtonRect = {
    current: null
};

export const connectionComponentRect = {
    current: null
};

export const navigationBarMenuContainerRect = {
    current: null
};

export const layoutOverlayRect = {
    current: null
};

export const remoteVideoMenuRect = {
    current: null
};

export const hangupRect = {
    current: null
};

export const hangupButtonRect = {
    current: null
};

export const shareMenuRect = {
    current: null
};

export const overflowMenuRect = {
    current: null
};

export const overflowMenuButtonRect = {
    current: null
};

export const reactionsMenuRect = {
    current: null
};

export const reactionsButtonRect = {
    current: null
};


/**
 * The name of the {@code MHConference} property which identifies the URL of
 * the conference represented by the {@code MHConference} instance.
 *
 * TODO It was introduced in a moment of desperation. Meet Hour SDK for Android
 * and iOS needs to deliver events from the JavaScript side where they originate
 * to the Java and Objective-C sides, respectively, where they are to be
 * handled. The URL of the {@code MHConference} was chosen as the identifier
 * because the Java and Objective-C sides join by URL through their respective
 * loadURL methods. But features/base/connection's {@code locationURL} is not
 * guaranteed at the time of this writing to match the {@code MHConference}
 * instance when the events are to be fired. Patching {@code MHConference}
 * from the outside is not cool but it should suffice for now.
 */
export const MH_CONFERENCE_URL_KEY = Symbol('url');

export const TRIGGER_READY_TO_CLOSE_REASONS = {
    'dialog.sessTerminatedReason': 'The meeting has been terminated',
    'lobby.lobbyClosed': 'Lobby room closed.'
};

/**
 * Conference leave reasons.
 */
export const CONFERENCE_LEAVE_REASONS = {
    SWITCH_ROOM: 'switch_room',
    UNRECOVERABLE_ERROR: 'unrecoverable_error'
};


export const REDUCE_ALL_USER_VOLUME_TEMPORARILY = 'reduce-all-user-volume-temporarily';

